import React from 'react';
import * as PropTypes from 'prop-types';
import useClassNames from '@medflex/hooks/useClassNames';
import OptionCard from '../OptionCard';

const BasicOptionCard = ({
  value,
  variant,
  label,
  description,
  iconName,
  onChange,
  isSelected,
  isDisabled,
  labelName,
}) => {
  const variantStyles = useClassNames(
    () => [
      'ring-1 ring-inset',
      isSelected && 'bg-blue-100 ring-blue-500 hover:bg-blue-100 hover:ring-blue-500',
      !isSelected && 'hover:shadow bg-white ring-slate-200 hover:bg-slate-100 hover:ring-slate-300',
    ],
    [isSelected],
  );
  return (
    <OptionCard
      onChange={onChange}
      isDisabled={isDisabled}
      isSelected={isSelected}
      value={value}
      variantStyles={variantStyles}
      labelName={labelName}
      iconName={iconName}
    >
      <div className="flex justify-between w-full">
        <div className="flex items-center">
          <OptionCard.Control
            isSelected={isSelected}
            isDisabled={isDisabled}
            variant={variant}
            labelName={labelName}
            controlId={value}
            value={value}
          />
          <div className="mx-6 text-left">
            <div>{label}</div>
            {description && <div className="font-normal text-slate-600">{description}</div>}
          </div>
        </div>
        {!!iconName && <OptionCard.Icon iconName={iconName} />}
      </div>
    </OptionCard>
  );
};

BasicOptionCard.propTypes = {
  value: PropTypes.any.isRequired,
  variant: PropTypes.oneOf(['radio', 'checkbox']).isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  description: PropTypes.string,
  labelName: PropTypes.string.isRequired,
  iconName: PropTypes.string,
  onChange: PropTypes.func,
  isSelected: PropTypes.bool,
  isDisabled: PropTypes.bool,
};

export default BasicOptionCard;
